import { render, staticRenderFns } from "./Evidenciada.vue?vue&type=template&id=afc5836e"
import script from "./Evidenciada.vue?vue&type=script&lang=js"
export * from "./Evidenciada.vue?vue&type=script&lang=js"
import style0 from "./Evidenciada.vue?vue&type=style&index=0&id=afc5836e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports